import { Component, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { User } from 'src/app/admin/1.tv/models/user.model';
import { AppService } from 'src/app/app.service';
import { StripeResponseService } from 'src/app/services/stripe-response.service';


@Component({
  selector: 'app-admir-user-menu',
  templateUrl: './admir-user-menu.component.html',
  styleUrls: ['./admir-user-menu.component.scss']
})
export class AdmirUserMenuComponent implements OnInit {
  public isUserEmailVeried: string;
  public userId = '';
  public userImage: any;
  public userName: string;
  public userEmail: string;
  public user: Observable<User>;

  constructor(
     public appService: AppService,
     public stripeResponseService: StripeResponseService) { }

  ngOnInit(): void {
    this.user = of(this.stripeResponseService.currentLoggedInUser);

  }

}
